import React from 'react'
import { Controller } from "react-hook-form"
import { Input } from '@/components/ui'

const GLIInfoSection = ({control, errors = {}, apiErrors = {}}) => (
  <div className="card bg-base-100 border border-base-200 rounded-none mb-4">
    <div className="card-body p-2">
      <h2 className="text-xl mb-2">Informations GLI</h2>
      
      <div className="grid grid-cols-2 gap-2 items-center">
        <div className="flex flex-col items-center gap-2">
          <Controller
            name="gli"
            control={control}
            defaultValue={false}
            render={({ field: { onChange, value, ...field } }) => (
              <label className="label cursor-pointer w-2/3">
                <span className="mr-4">Locataire sous GLI</span>
                <input 
                  type="checkbox" 
                  className="toggle toggle-md"
                  checked={value || false} 
                  onChange={(e) => onChange(e.target.checked)} 
                  {...field}
                />
              </label>
            )}
          />
          <Input.Text control={control}
            name="numero_caf"
            label="Numéro de CAF"
            className="w-2/3"
          />
        </div>
        <div className="flex flex-col items-center gap-2">
          <Controller
            name="garants"
            control={control}
            defaultValue=""
            render={({ field }) => (
              <>
                <label className="label">Garants</label>
                <textarea 
                  className="textarea textarea-bordered w-full" 
                  {...field}
                  value={field.value || ''} 
                />
              </>
            )}
          />
        </div>
      </div>
    </div>
  </div>
)

export default GLIInfoSection;